import { MouseEventHandler, ReactNode } from 'react';

import { ButtonType } from '@components/Button/ButtonInterface';

import {
  ResponsiveSearchDrawerButton,
  ResponsiveSearchSubmitButtonWrapper,
} from './ResponsiveApplyButtonStyle';

interface IResponsiveApplyButton {
  title?: ReactNode;
  onClick?: MouseEventHandler<HTMLElement>;
  isTravelPlanning?: boolean;
  type?: ButtonType;
}

const ResponsiveApplyButton = ({
  title = 'Uygula',
  onClick,
  isTravelPlanning = false,
  type = 'primary',
}: IResponsiveApplyButton) => {
  return (
    <ResponsiveSearchSubmitButtonWrapper isTravelPlanning={isTravelPlanning}>
      <ResponsiveSearchDrawerButton
        htmlType='submit'
        type={type}
        onClick={onClick}
        block
      >
        {title}
      </ResponsiveSearchDrawerButton>
    </ResponsiveSearchSubmitButtonWrapper>
  );
};

export default ResponsiveApplyButton;
